import Spinner from '@shared/components/Spinner';
import styles from './TabContentSpinner.module.css';

export const TabContentSpinner = (): React.ReactElement => (
  <div className={styles.spinerContainer}>
    <Spinner />
  </div>
);
